// config.js
// const BASE_URL = `https://mymunc.com`;
// const BASE_URL = `http://192.168.1.14:8080`;
const BASE_URL = "https://mymunc.com";
// const BASE_URL = `https://mymunc.com`;

// const BASE_URL = `https://kasperblognew.onrender.com`;
// const BASE_URL = `https://blogmymunc-com.onrender.com`;
export default BASE_URL;
